<script>
    import { onMount } from "svelte";
    import { Link, navigate } from "svelte-routing";
    import { track } from '../analytics.svelte';
    import BetaOptIn from '../components/BetaOptIn.svelte';
    import Login from '../components/Login.svelte';

    window.REQUIRED_CODE_ERROR_MESSAGE = 'Please choose a country code';
    window.LOCALE = 'en';
    window.EMAIL_INVALID_MESSAGE = window.SMS_INVALID_MESSAGE = "The information provided is invalid. Please review the field format and try again.";
  
    window.REQUIRED_ERROR_MESSAGE = "This field cannot be left blank. ";
  
    window.GENERIC_INVALID_MESSAGE = "The information provided is invalid. Please review the field format and try again.";
  
    window.translation = {
      common: {
        selectedList: '{quantity} list selected',
        selectedLists: '{quantity} lists selected'
      }
    };

    let emailAddress = '';

    // function trackBetaSignup(email) {
    //     track('beta-signup', { email });
    // };

    const trackBetaSignup = (email) => {
        track('beta-signup', { email });
    }
  
    var AUTOHIDE = Boolean(0);
</script>

<!-- What are your initial impressions?
Who do you think is the target audience?
Is the value prop clear to you?
How important is the design of this landing page in your impressions of it? -->

<!-- <svelte:head>
	<script src="https://sibforms.com/forms/end-form/build/main.js" ></script>
	<link rel="stylesheet" href="https://sibforms.com/forms/end-form/build/sib-styles.css">
</svelte:head> -->

<main style="">
    <div style="">
        <div style="">
            <div style="" class="page-primary">
                <div style="padding:10px;text-align:center;">
                    <h2 
                        class="main-header"
                        style="">
                        <!-- Learn Faster with Evergreen Feeds -->

                        <!-- Cut through information overload -->

                        <!-- The internet is noisy. <br>
                        Find the signal with friends. -->

                        save for later, <br>
                        learn faster, <br>
                        get smarter, <br>
                        with friends
                    </h2>
                    <!-- <p style="font-weight:500;max-width: 500px;margin:auto;margin-top:20px;margin-bottom:30px;font-size:16px;line-height:1.5em;">                        
                        Easily build <b>automated feeds</b> organized by <b>your interests</b>, with content pulled from blogs, publications and social media.
                        <b>No coding required</b>
                    </p> -->
                    <!-- <h4>a smarter social bookmarking experience</h4> -->
                    <p>
                        <Login prompt={"a smarter social bookmarking experience"}/>
                    </p>
                </div>
            </div>
        </div>


        <!-- <div style="background:white;padding-top:30px;padding-bottom:30px;">
            <div style="min-height:450px;position:relative;max-width:600px;margin:auto;">
                <div style="text-align:center;">
                    <h2 style="margin-bottom:50px;">Check out these custom feeds for inspiration</h2>
                    <Icon data={arrowCircleDown} scale={3}/>
                </div>
                <div class="feed-links-container grid">

                    <Link to="/f/business" class="link">
                        <span class="feed-link" style="background-color:#759FBC">Business</span>
                    </Link>

                    <Link to="/f/realEstate" class="link">
                        <span class="feed-link" style="background-color:#FF674D">Real Estate</span>
                    </Link>

                    <Link to="/f/health" class="link">
                        <span class="feed-link" style="background-color:#FED766">Health & Wellness</span>
                    </Link>

                    <Link to="/f/crypto" class="link">
                        <span class="feed-link" style="background-color:#305252">Crypto</span>
                    </Link>

                    <Link to="/f/tutorials" class="link">
                        <span class="feed-link" style="background-color:#160C28">Creator Tutorials</span>
                    </Link>

                    <Link to="/f/story" class="link">
                        <span class="feed-link" style="background-color:#AB464F">Story</span>
                    </Link>

                    <Link to="/f/onlineBusiness" class="link">
                        <span class="feed-link" style="background-color:#FF674D">Online Business</span>
                    </Link>
                </div>
            </div>
        </div> -->
    </div>
</main>

<style>
    .feed-links-container {
        margin:auto;
        margin-top:50px;
    }
    .grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
        grid-gap: 1rem;
    }
    .feed-link {
        /* display: inline-block; */
        padding: 10px;
        font-weight: 500;
        background: white;
        height: 100px;
        width: 150px;
        display: flex;
        align-items: center;
        justify-content: center;
        color:white;
        font-size:24px;
        text-align:center;
    }
    main {
        /* color: rgb(70, 100, 70); */
    }
    .feed-link-anchor {
        text-decoration: none !important;
    }

    .step-container {
        display:flex;
        flex-direction: column;
    }
    .how-to-step {
        text-align:center;
        margin-bottom: 20px;
        /* width: 33%; */
    }

    a:visited {
        text-decoration: none;
    }

    a:hover {
        text-decoration: none !important;
    }

    a:active {
        text-decoration: none;
    }

    @font-face {
        font-display: fallback;
        font-family: 'Lato';
        font-style: bold;
        font-weight: 700;
        src: local('Lato Bold'), local('Lato-Bold'), url(https://fonts.gstatic.com/s/lato/v11/MgNNr5y1C_tIEuLEmicLm1KPGs1ZzpMvnHX-7fPOuAc.woff2) format('woff2');
        unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2212, U+2215, U+E0FF, U+EFFD, U+F000;
    }

    @font-face {
        font-family: 'Lato';
        font-style: normal;
        font-weight: 400;
        src: local('Lato Regular'), local('Lato-Regular'), url(https://fonts.gstatic.com/s/lato/v11/MDadn8DQ_3oT6kvnUq_2rxTbgVql8nDJpwnrE27mub0.woff2) format('woff2');
        unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2212, U+2215, U+E0FF, U+EFFD, U+F000;
    }
  
    
    h2 {
        font-family: Lato;
    }
    .page-primary {
        height:100vh;
        /* max-width: 600px; */
        margin:auto;display:flex;justify-content: center;align-items:center;
    }
    .main-header {
        font-size:54px;
        max-width:700px;
        margin:auto;
        margin-bottom:60px;
        color: #2a7e19;
    }

    @media only screen and (max-width: 767px) {
        .main-header {
            font-size: 34px;
        }
        #sib-form {
            flex-direction: column;
        }
        .step-container {
            flex-direction: column;
        }
        .how-to-step {
            text-align:left;
            width: 100%;
            margin:0 20px;
        }
        .how-to-step-text {
            margin: 20px 40px 20px 20px;
        }
    }
</style>